<template>
    <div class="patsnap-biz-user_center">
        <div
            v-if="!service.logged"
            class="patsnap-biz-user_center--not-logged-in"
            flex="-center"
        >
            <slot
                name="language"
            />

            <a
                class="pt-ui-btn patsnap-biz-user_center__btn"
                type="primary"
                _target="_self"
                :href="service.logoutHref"
                @click="handleLoginClick"
            >
                {{ $t('PtUserCenter.login') }}
            </a>
        </div>
        <PtHeaderDropdown
            v-else
            trigger="hover"
            class="patsnap-biz-user_center--logged"
        >
            <template #reference>
                <PtAvatar
                    v-click-outside="handleClickOutsideAvatar"
                    :username="service.name"
                    :avatar="service.avatar"
                    :avatar-color="service.avatarColor"
                    @click="handleClickAvatar"
                />
                <!--暂时不展示公司-->
                <!-- <div class="patsnap-biz-user_center--tenant">
                    <div class="patsnap-biz-user_center--tenant-name">
                        {{ service.TenantName }}
                    </div>
                    <div
                        v-if="service.IsEnterpriseUser"
                        class="patsnap-biz-user_center--tenant-tag enterprise"
                    >
                        {{ $t('PtUserCenter.enterprise') }}
                    </div>
                    <div
                        v-else
                        class="patsnap-biz-user_center--tenant-tag personal"
                    >
                        {{ $t('PtUserCenter.personal') }}
                    </div>
                </div> -->
            </template>
            <template #popper>
                <slot
                    name="header"
                    trigger="hover"
                />
                <PtList
                    ref="popper"
                    class="patsnap-biz-user_center_menu"
                    :items="items"
                >
                    <template #language>
                        <slot
                            name="language"
                            trigger="hover"
                        />
                    </template>
                    <template
                        v-for="name in tranformSlotNames"
                        #[name]
                    >
                        <slot
                            :name="name"
                        />
                    </template>
                </PtList>
            </template>
        </PtHeaderDropdown>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import PtList from '@patsnap-biz/list';
import PtHeaderDropdown from '@patsnap-biz/header-dropdown';
import { UserCenterService } from '@patsnap-utils/biz';
import PtAvatar from './Avatar';
import cn from '../locales/cn';
import en from '../locales/en';
import jp from '../locales/jp';
import tw from '../locales/tw';

export default {
    name: 'PtUserCenter',
    i18n: {
        fallbackLocale: 'cn',
        messages: {
            cn, en, jp, tw,
        },
    },
    directives: {
        ClickOutside,
    },
    components: {
        PtAvatar,
        PtList,
        PtHeaderDropdown,
    },
    props: {
        service: {
            type: Object,
            default() {
                return new UserCenterService();
            },
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        tranformSlotNames() {
            const slotNames = [
                'default',
                'language',
            ];
            const names = Object.keys(this.$slots).filter((name) => !slotNames.includes(name));
            return names;
        },
        items() {
            return this.service.items.map((item) => {
                if (item === null) return null;
                if (typeof item === 'string') {
                    return this.$te(item) ? this.$t(item) : item;
                }
                const {
                    i18n, label, key, ...rest
                } = item;
                return {
                    label: this.$t(i18n) ? this.$t(i18n) : (label || i18n),
                    key,
                    ...rest,
                };
            });
        },
    },
    watch: {
        visible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.popupItem = this.$refs.popper.$el;
                });
            } else {
                this.popupItem = undefined;
            }
        },
    },
    methods: {
        handleClickAvatar() {
            this.visible = !this.visible;
        },
        handleClickOutsideAvatar() {
            this.visible = false;
        },
        handleLoginClick(event) {
            if (this.service.beforeLogin) {
                event.preventDefault();
                const { loginHref, logoutHref } = this.service;
                this.service.beforeLogin({ loginHref, logoutHref });
            }
        },
    },
};
</script>
